<div *ngIf="progressNum | lmsCheckNoData" class="primary gl-circle-chart progress-{{ progressNum | number : '1.0-0' }}">
  <div class="gl-circle-chart__slice">
    <div class="gl-circle-chart__bar"></div>
    <div class="gl-circle-chart__fill"></div>
  </div>
</div>
